module.exports = __webpack_public_path__ + "img/hifu_single01.05945462.png";